import type { ChatMessage } from "~/entities/chat";

export interface MessageDateGroup {
    dateKey: string;
    date: Date;
    messages: ChatMessage[];
}

function dateKey(d: Date): string {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
}

function startOfDay(d: Date): Date {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

// Группируем сообщения по календарной дате `createdAt`. Сохраняем
// серверный порядок (ASC). Соседние сообщения с одной датой
// сливаются в одну группу.
export function groupMessagesByDate(messages: readonly ChatMessage[]): MessageDateGroup[] {
    const groups: MessageDateGroup[] = [];
    for (const message of messages) {
        const date = new Date(message.createdAt);
        const key = dateKey(date);
        const last = groups[groups.length - 1];
        if (last?.dateKey === key) {
            last.messages.push(message);
        } else {
            groups.push({ dateKey: key, date: startOfDay(date), messages: [message] });
        }
    }
    return groups;
}
